// imports
import type { StyleSpecification } from 'maplibre-gl';

// local imports
import usgsTopo from '../assets/thumbnails/usgs-topo.jpg';
import usgsImageryTopo from '../assets/thumbnails/usgs-imagery-topo.png';
import usgsImageryOnly from '../assets/thumbnails/usgs-imagery-only.png';
import usgsShadedRelief from '../assets/thumbnails/usgs-shaded-relief.png';
import usgsHydroCached from '../assets/thumbnails/usgs-hydro-cached.png';
import openStreets from '../assets/thumbnails/osm.jpg';
import streets from '../assets/thumbnails/streets.jpg';
import light from '../assets/thumbnails/light.png';
import dark from '../assets/thumbnails/dark.png';
import none from '../assets/thumbnails/none.png';

export type BASEMAP_STYLE = StyleSpecification | string;
export type BASEMAP_OPTION = {
  identifier: string;
  mapStyle: BASEMAP_STYLE;
  thumbnail: string;
};

export const BASEMAPS: BASEMAP_OPTION[] = [
  {
    identifier: 'Topographic',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/WMTS/tile/1.0.0/USGSTopo/default/GoogleMapsCompatible/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'usgs-topo',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: usgsTopo,
  },
  {
    identifier: 'Imagery Topo',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/WMTS/tile/1.0.0/USGSImageryTopo/default/GoogleMapsCompatible/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'usgs-imagery-topo',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: usgsImageryTopo,
  },
  {
    identifier: 'Imagery',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/WMTS/tile/1.0.0/USGSImageryOnly/default/GoogleMapsCompatible/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'usgs-imagery-only',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: usgsImageryOnly,
  },
  {
    identifier: 'Shaded Relief',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://basemap.nationalmap.gov/arcgis/rest/services/USGSShadedReliefOnly/MapServer/WMTS/tile/1.0.0/USGSShadedReliefOnly/default/GoogleMapsCompatible/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'usgs-shaded-relief',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: usgsShadedRelief,
  },
  {
    identifier: 'Hydro Cached',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://basemap.nationalmap.gov/arcgis/rest/services/USGSHydroCached/MapServer/WMTS/tile/1.0.0/USGSHydroCached/default/GoogleMapsCompatible/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'usgs-hydro-cached',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: usgsHydroCached,
  },
  {
    identifier: 'Open Streets',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'open-streets',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: openStreets,
  },
  {
    identifier: 'Streets',
    mapStyle: {
      version: 8,
      sources: {
        usgs: {
          type: 'raster',
          tiles: [
            'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
          ],
          tileSize: 256,
        },
      },
      layers: [
        {
          id: 'streets',
          type: 'raster',
          source: 'usgs',
          minzoom: 0,
          maxzoom: 23,
        },
      ],
    },
    thumbnail: streets,
  },
  {
    identifier: 'Light',
    mapStyle: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
    thumbnail: light,
  },
  {
    identifier: 'Dark',
    mapStyle:
      'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',
    thumbnail: dark,
  },
  {
    identifier: 'No Basemap',
    mapStyle: {
      version: 8,
      sources: {},
      layers: [],
    },
    thumbnail: none,
  },
];
